/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* HC - Product Template - ShopPay banner variant update - 01 Mar '22 */
const updateColorLogoSPI = () => {
  document.querySelector('shopify-payment-terms').shadowRoot.querySelector('.shopify-installments shop-pay-logo').shadowRoot.querySelectorAll('svg path').forEach( path => path.style.fill = '#000000');
  document.querySelector('shopify-payment-terms').style.display = "block";
}

window.addEventListener('load',function(){
  document.querySelector('shopify-payment-terms').shadowRoot.getElementById('shopify-installments-cta').style.outline = 'none';
  updateColorLogoSPI();
})

document.addEventListener('variant:changed', function(event) {
  var shopPay = document.querySelector("shopify-payment-terms");
  shopPay.setAttribute("variant-id", event.detail.variant.id);
  updateColorLogoSPI();
});